var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tui-notice-board",attrs:{"bindtap":"goWebview"}},[_c('div',{staticClass:"tui-icon-bg"},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/icon/gonggao-2@2x.png")}})]),_c('div',{staticClass:"tui-scorll-div",attrs:{"bindtap":"detail"}},[_c('div',{staticClass:"tui-notice tui-animation"},[_vm._v("双11活动预告：全场5折，8折，9折起！")])])])
}]

export { render, staticRenderFns }